/* Optional presentation around the native quantity field; no cart or variant interception. */
(() => {
  if (customElements.get('tb-product-quantity')) return;
  customElements.define('tb-product-quantity', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.input = this.querySelector('input[name="quantity"]');
      if (!this.input) return;
      this.events = new AbortController();
      this.dataset.enhanced = 'true';
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-quantity-step]');
        if (!button || !this.contains(button) || button.disabled || this.input.disabled || this.input.readOnly) return;
        const root = this.closest('tb-product');
        if (root?.getAttribute('aria-busy') === 'true' || root?.hasAttribute('data-variant-error')) return;
        const {min, max, step} = this.limits();
        const value = this.input.valueAsNumber;
        const direction = Number(button.dataset.quantityStep);
        if (!Number.isFinite(value) || value < min) this.input.value = String(min);
        else if (value > max) this.input.value = String(min + Math.floor((max - min) / step) * step);
        else {
          try { direction > 0 ? this.input.stepUp() : this.input.stepDown(); }
          catch (_) { this.input.value = String(min); }
        }
        this.input.dispatchEvent(new Event('input', {bubbles: true}));
        this.input.dispatchEvent(new Event('change', {bubbles: true}));
      }, {signal: this.events.signal});
      this.addEventListener('input', () => this.sync(), {signal: this.events.signal});
      this.addEventListener('change', () => this.sync(), {signal: this.events.signal});
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.input, {attributes: true, attributeFilter: ['min', 'max', 'step', 'disabled', 'readonly']});
      const root = this.closest('tb-product');
      if (root) this.observer.observe(root, {attributes: true, attributeFilter: ['aria-busy', 'data-variant-error']});
      this.sync();
    }
    limits() {
      const min = this.input.min === '' ? 1 : Number(this.input.min);
      const max = this.input.max === '' ? Infinity : Number(this.input.max);
      const step = Number(this.input.step) || 1;
      return {min: Number.isFinite(min) ? min : 1, max: Number.isFinite(max) ? max : Infinity, step};
    }
    sync() {
      const {min, max, step} = this.limits();
      const value = this.input.valueAsNumber;
      const root = this.closest('tb-product');
      const inactive = this.input.disabled || this.input.readOnly || root?.getAttribute('aria-busy') === 'true' || root?.hasAttribute('data-variant-error');
      const upper = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : max;
      this.querySelector('[data-quantity-step="-1"]').disabled = inactive || (Number.isFinite(value) && value <= min);
      this.querySelector('[data-quantity-step="1"]').disabled = inactive || (Number.isFinite(value) && value >= upper);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.events = null;
      delete this.dataset.enhanced;
    }
  });
})();
